import script from "./ToolbarActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarActionButton.vue?vue&type=script&setup=true&lang=js"

import "./ToolbarActionButton.vue?vue&type=style&index=0&id=5f235cdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f235cdc"]])

export default __exports__